import classNames from "classnames";
import { map } from "lodash";
import React, { HTMLAttributes, ReactNode, useState } from "react";

import ChevronDownIcon from "ac-components/ac-icons/ChevronDownIcon";
import ChevronRightIcon from "ac-components/ac-icons/ChevronRightIcon";

import "./ACMetadataPanel.less";

type ACMetadataPanelProps = {
  children: ReactNode | ReactNode[];
};

export default function ACMetadataPanel({ children }: ACMetadataPanelProps) {
  const prefixCls = "ac-metadata-panel";
  return <div className={prefixCls}>{children}</div>;
}

type SectionRow = { label: ReactNode; value: ReactNode };

const Section = ({
  title,
  labelWidth,
  rows,
  children,
  className,
  defaultExpanded = true,
}: {
  title: ReactNode | ReactNode[];
  labelWidth?: number;
  rows?: SectionRow[];
  children?: ReactNode | ReactNode[];
  className?: string;
  defaultExpanded?: boolean;
}) => {
  const prefixCls = `ac-metadata-section`;
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <div className={`${prefixCls} layout-xs ${className}`}>
      <div
        className={`${prefixCls}-title text-section-subtitle`}
        onClick={() => setExpanded((prev) => !prev)}
      >
        {expanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
        {title}
      </div>
      {expanded ? (
        <>
          {map(rows, (row, i) => {
            return (
              <FieldRow key={i}>
                <FieldLabel width={labelWidth}>{row.label}</FieldLabel>
                <FieldValue>{row.value}</FieldValue>
              </FieldRow>
            );
          })}
          {children}
        </>
      ) : null}
    </div>
  );
};

const FieldRow = ({
  className,
  ...restProps
}: Pick<HTMLAttributes<HTMLDivElement>, "children" | "className">) => (
  <div className={`ac-metadata-panel-field-row ${className}`} {...restProps} />
);
const FieldLabel = ({
  width = 100,
  children,
}: { width?: number } & Pick<HTMLAttributes<HTMLDivElement>, "children">) => (
  <div className={`field-label text-small-highlight`} style={{ width }}>
    {children}
  </div>
);
const FieldValue = ({
  className,
  ...rest
}: Pick<
  HTMLAttributes<HTMLDivElement>,
  "children" | "title" | "className" | "style"
>) => <div className={classNames("field-value", className)} {...rest} />;

ACMetadataPanel.Section = Section;
ACMetadataPanel.Row = FieldRow;
ACMetadataPanel.Label = FieldLabel;
ACMetadataPanel.Value = FieldValue;
